import { useTranslation } from "react-i18next";
import styles from "./Bio.module.css";

export default function Bio({ name, position, email, description, photo }) {
    const { t } = useTranslation();

    return (
        <div className={styles.bio}>
            <div className={styles.photoWrapper}>
                {photo ? (
                    <img src={photo} alt={`${name} photo`} className={styles.photo} />
                ) : (
                    <div className={styles.placeholder}>{t("bio.noPhoto")}</div>
                )}
            </div>
            <div className={styles.info}>
                <h2 className={styles.name}>{name}</h2>

                <h3 className={styles.position}>{position}</h3>
                <p className={styles.description}>{description}</p>
                <a href={`mailto:${email}`} className={styles.email}>
                    {email}
                </a>
            </div>
        </div>
    );
}
